/**
 * Native Shopify shipping rates calculator for cart drawer.
 * Event delegation so it keeps working after cart AJAX re-renders.
 */
(function () {
  const ROOT = '[data-taupe-shipping-calculator]';

  function money(centsOrString, format) {
    const amount =
      typeof centsOrString === 'string' && centsOrString.includes('.')
        ? Math.round(parseFloat(centsOrString) * 100)
        : parseInt(centsOrString, 10);

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount, format);
    }

    const value = (Number.isFinite(amount) ? amount / 100 : 0).toFixed(2);
    if (!format) return `£${value}`;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(amount / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function fillProvinces(root) {
    const countrySelect = root.querySelector('[data-shipping-country]');
    const provinceSelect = root.querySelector('[data-shipping-province]');
    const provinceWrap = root.querySelector('[data-shipping-province-wrap]');
    if (!countrySelect || !provinceSelect || !provinceWrap) return;

    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
    let provinces = [];

    if (selectedOption?.dataset?.provinces) {
      try {
        provinces = JSON.parse(selectedOption.dataset.provinces);
      } catch (e) {
        provinces = [];
      }
    }

    const countries = window.Countries;
    if ((!provinces || !provinces.length) && countries) {
      const countryName = selectedOption?.text || countrySelect.value;
      if (countries[countryName]?.provinces) {
        provinces = countries[countryName].provinces;
      }
    }

    provinceSelect.innerHTML = '';
    if (!provinces || provinces.length === 0) {
      provinceWrap.hidden = true;
      provinceSelect.innerHTML = '<option value=""></option>';
      return;
    }

    provinceWrap.hidden = false;
    provinces.forEach((province) => {
      const name = Array.isArray(province) ? province[0] : province;
      const code = Array.isArray(province) ? province[1] || province[0] : province;
      const opt = document.createElement('option');
      opt.value = code;
      opt.textContent = name;
      provinceSelect.appendChild(opt);
    });
  }

  function setOpen(root, open) {
    const toggle = root.querySelector('[data-shipping-toggle]');
    const panel = root.querySelector('[data-shipping-panel]');
    const caret = root.querySelector('.taupe-shipping-calculator__caret');
    if (!toggle || !panel) return;

    root.classList.toggle('is-open', open);
    if (open) panel.removeAttribute('hidden');
    else panel.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (caret) caret.textContent = open ? '−' : '+';
  }

  async function calculate(root) {
    const status = root.querySelector('[data-shipping-status]');
    const ratesList = root.querySelector('[data-shipping-rates]');
    const countrySelect = root.querySelector('[data-shipping-country]');
    const provinceSelect = root.querySelector('[data-shipping-province]');
    const zipInput = root.querySelector('[data-shipping-zip]');
    const format = root.dataset.moneyFormat || '';

    const country = countrySelect?.value || '';
    const province = provinceSelect && !provinceSelect.closest('[hidden]') ? provinceSelect.value : '';
    const zip = zipInput?.value?.trim() || '';

    if (!country) {
      status.textContent = 'Please select a country.';
      ratesList.hidden = true;
      ratesList.innerHTML = '';
      return;
    }

    status.textContent = 'Calculating…';
    ratesList.hidden = true;
    ratesList.innerHTML = '';

    const params = new URLSearchParams();
    params.set('shipping_address[country]', country);
    if (province) params.set('shipping_address[province]', province);
    if (zip) params.set('shipping_address[zip]', zip);

    const rootUrl = window.Shopify?.routes?.root || '/';

    try {
      const response = await fetch(`${rootUrl}cart/shipping_rates.json?${params.toString()}`, {
        headers: { Accept: 'application/json' },
      });

      let data = null;
      try {
        data = await response.json();
      } catch (e) {
        data = null;
      }

      if (!response.ok) {
        const message =
          (data && (data.error || data.message)) ||
          (Array.isArray(data) ? data.join(' ') : null) ||
          'Unable to calculate shipping for this address.';
        status.textContent = typeof message === 'string' ? message : 'Unable to calculate shipping for this address.';
        return;
      }

      const rates = data?.shipping_rates || [];
      if (!rates.length) {
        status.textContent = 'No shipping rates available for this destination.';
        return;
      }

      status.textContent = `${rates.length} shipping rate${rates.length === 1 ? '' : 's'} available:`;
      ratesList.hidden = false;
      ratesList.innerHTML = rates
        .map((rate) => {
          const priceNum = Number(rate.price);
          const price = priceNum === 0 ? 'Free' : money(rate.price, format);
          return `<li class="taupe-shipping-calculator__rate"><span>${rate.name || rate.presentment_name || 'Shipping'}</span><strong>${price}</strong></li>`;
        })
        .join('');
    } catch (error) {
      status.textContent = 'Unable to calculate shipping right now. Please try again.';
      console.error('[taupe shipping calculator]', error);
    }
  }

  function onClick(event) {
    const toggle = event.target.closest('[data-shipping-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const root = toggle.closest(ROOT);
      if (!root) return;
      setOpen(root, !root.classList.contains('is-open'));
      return;
    }

    const submit = event.target.closest('[data-shipping-submit]');
    if (submit) {
      event.preventDefault();
      event.stopPropagation();
      const root = submit.closest(ROOT);
      if (root) calculate(root);
    }
  }

  function onChange(event) {
    const country = event.target.closest('[data-shipping-country]');
    if (!country) return;
    const root = country.closest(ROOT);
    if (root) fillProvinces(root);
  }

  function prepareAll() {
    document.querySelectorAll(ROOT).forEach((root) => {
      fillProvinces(root);
      if (!root.classList.contains('is-open')) {
        const panel = root.querySelector('[data-shipping-panel]');
        if (panel) panel.setAttribute('hidden', '');
      }
    });
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('change', onChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareAll);
  } else {
    prepareAll();
  }

  window.TaupeShippingCalculator = {
    refresh: prepareAll,
  };

  document.addEventListener('shipping-rates-widget:refresh', () => {
    window.setTimeout(prepareAll, 50);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      window.setTimeout(prepareAll, 150);
    });
  }
})();
